$(function () {
    $(document).ready(function () {
        const $close = $('.drawer__close');
        const $back = $('.drawer__back');
        const $login = $('.mobile-nav__item--login');
        const $submenus = $('.nav__submenu');
        const $outerMenu = $('#mobile-nav-nav .site-sub__nav--mobile');
        const outerSubMenuSelector = '.mobile-nav__submenu';

        $('.drawer__back').on('click', function (e) {
            e.preventDefault();
            const previous = $('.show-subnav').data('previous');

            $submenus.removeClass("show-subnav");

            $.each($submenus, function () {
                if ($(this).attr('id') === previous) {
                    $(this).addClass('show-subnav');
                    const previousElement = $('#' + previous);
                    const previousText = previousElement?.data('text') ? previousElement?.data('text') : 'WEBSHOP';
                    $('#drawer__back--text').html(previousText);
                    $login.hide();
                    $outerMenu.hide();
                }
            });

            if (!previous) {
                $close.show();
                $login.show();
                $outerMenu.show();
                $back.hide();
                $(outerSubMenuSelector).show();
            }
        });

        $("li:has(ul)").find("a").on('click', function (e) {
            if ($(this).data('next')) {
                e.preventDefault();
                const next = $(this).data('next');

                $submenus.removeClass("show-subnav");
                $close.hide();
                $back.css('display', 'flex');
                $login.hide();
                $outerMenu.hide();
                $(outerSubMenuSelector).hide();

                $.each($submenus, function () {
                    if ($(this).attr('id') === next) {
                        $(this).addClass('show-subnav');
                        const previousText = $(this).data('text') ? $(this).data('text') : 'WEBSHOP';
                        $('#drawer__back--text').html(previousText);
                        $(this).parents(outerSubMenuSelector).show();
                    }
                })
            }
        })
    });
});